var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { useState } from "react";
import { integerExp } from "../../web/utils/regex";
var YobInputField = function (props) {
    var _a;
    var _b = __read(useState(["", "", "", ""]), 2), InpValue = _b[0], setInpValue = _b[1];
    var _c = __read(useState("focus"), 2), focusClass = _c[0], setFocusClass = _c[1];
    function handleChange(e, i) {
        if (integerExp.test(e.currentTarget.value)) {
            var valueCopy = __spreadArray([], __read(InpValue), false);
            valueCopy[i] = e.currentTarget.value;
            setInpValue(valueCopy);
            props.onChange(valueCopy.join(""));
            var _a = e.currentTarget, maxLength = _a.maxLength, value = _a.value, name_1 = _a.name;
            var _b = __read(name_1.split("-"), 2), fieldName = _b[0], fieldIndex = _b[1];
            var fieldIntIndex = parseInt(fieldIndex, 10);
            if (value.length >= maxLength && fieldIntIndex < InpValue.length) {
                var nextfield = document.querySelector("input[name=InpfieldName-".concat(fieldIntIndex + 1).concat(props.inputClassName ? props.inputClassName : "", "]"));
                if (nextfield !== null) {
                    nextfield === null || nextfield === void 0 ? void 0 : nextfield.focus();
                }
            }
        }
    }
    var maxLengthCheck = function (event) {
        if (event.currentTarget.value.length > event.currentTarget.maxLength) {
            event.currentTarget.value = event.currentTarget.value.slice(0, event.currentTarget.maxLength);
        }
    };
    function handleKeyDown(e, i) {
        if (e.keyCode === 8 && !InpValue[i] && i > 0) {
            var prevField = document.querySelector("input[name=InpfieldName-".concat(i - 1).concat(props.inputClassName ? props.inputClassName : "", "]"));
            if (prevField !== null) {
                prevField === null || prevField === void 0 ? void 0 : prevField.focus();
            }
        }
    }
    React.useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.resetOTP) {
            if (props === null || props === void 0 ? void 0 : props.numberOfInputs) {
                setInpValue(Array(props === null || props === void 0 ? void 0 : props.numberOfInputs).fill(""));
            }
            else {
                setInpValue(["", "", "", ""]);
            }
        }
    }, [props === null || props === void 0 ? void 0 : props.resetOTP]);
    React.useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.numberOfInputs) {
            setInpValue(Array(props === null || props === void 0 ? void 0 : props.numberOfInputs).fill(""));
        }
    }, [props === null || props === void 0 ? void 0 : props.numberOfInputs]);
    return (React.createElement("div", { className: "yob_inp_grp ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") }, InpValue.map(function (_, i) {
        var _a;
        return (React.createElement("input", { key: i, placeholder: props.placeholder, value: InpValue[i] !== "" ? InpValue[i] : "", onChange: function (e) { return handleChange(e, i); }, onFocus: function () { return setFocusClass(" focus"); }, onBlur: function () { return setFocusClass(" "); }, className: "yob_inp mg-b10" + focusClass, type: props.type ? props.type : "password", min: props.min ? props.min : 0, max: props.max ? props.max : 9, maxLength: 1, onKeyUp: function (e) { return props.handleKeyUp && props.handleKeyUp(e, i); }, onKeyDown: function (e) { return handleKeyDown(e, i); }, id: props.id ? props.id + i : "yob-" + i, autoFocus: (props === null || props === void 0 ? void 0 : props.autofocusIndex) === i, disabled: props.disabled, onInput: function (e) { return maxLengthCheck(e); }, name: "InpfieldName-".concat(i.toString()).concat(props.inputClassName ? props.inputClassName : ""), autoComplete: (_a = props === null || props === void 0 ? void 0 : props.autoComplete) !== null && _a !== void 0 ? _a : "off" }));
    })));
};
export default YobInputField;
